import * as React from 'react';
import { connect } from 'react-redux';
import {
  SettingTabPanelListRow,
  SettingTabPanelListRowImageTitle,
} from '../../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../../common/ToolIconRadioButtonSet';
import ObjectDrawingUIAction from '../../../actions/ui/ObjectDrawingUIAction';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../../reducers/app';
import { ShapeKind, LineType } from '../../../drawing/types';
import SelectableNormalIconButton
  from '../../common/SelectableIconButton/SelectableNormalIconButton';

interface ShapeKindTabPanelListRowProps {
  selected: number;
  lineType: LineType;
  shapeKind: ShapeKind;
  dispatch: Dispatch<Action>;
}

const titleContainerStyle: React.CSSProperties = {
  width: '105px',
};

const titleStyle: React.CSSProperties = {
  width: '92px',
};

const overrideLineTypeIfNeeded = (lineType: LineType, dispatch: Dispatch<Action>) => {
  // 直線(水平垂直/2点間)描画時に線の種類無し(塗りモード)のままだと何も描画されないので
  // その場合は強制的に実線を選択する
  if (lineType === LineType.None) {
    ObjectDrawingUIAction.setLineType(0, LineType.Solid, dispatch);
  }
};

const ShapeKindTabPanelListRow: React.SFC<
  ShapeKindTabPanelListRowProps
> = React.memo((props) => {
  const { selected, lineType, shapeKind, dispatch } = props;

  return (
    <SettingTabPanelListRow>
      <SettingTabPanelListRowImageTitle
        imgName="text_shape_type"
        containerStyle={titleContainerStyle}
        imageStyle={titleStyle} />
      <ToolIconRadioButtonSet style={{ width: '320px' }}>
        <SelectableNormalIconButton
          title="直線（水平垂直）"
          imagePath="images/setting-popup/object-drawing/btn_line_straight"
          active={shapeKind === ShapeKind.AxisAlignedStraightLine}
          onClick={() => {
            overrideLineTypeIfNeeded(lineType, dispatch);
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.AxisAlignedStraightLine,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="直線（２点間の切替）"
          imagePath="images/setting-popup/object-drawing/btn_line_two_points"
          active={shapeKind === ShapeKind.StraightLine}
          onClick={() => {
            overrideLineTypeIfNeeded(lineType, dispatch);
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.StraightLine,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="円"
          imagePath="images/setting-popup/object-drawing/btn_circle_01"
          active={shapeKind === ShapeKind.Circle}
          onClick={() => {
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.Circle,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="楕円"
          imagePath="images/setting-popup/object-drawing/btn_circle_02"
          active={shapeKind === ShapeKind.Oval}
          onClick={() => {
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.Oval,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="四角"
          imagePath="images/setting-popup/object-drawing/btn_square_01"
          active={shapeKind === ShapeKind.Square}
          onClick={() => {
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.Square,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="長方形"
          imagePath="images/setting-popup/object-drawing/btn_square_02"
          active={shapeKind === ShapeKind.Rect}
          onClick={() => {
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.Rect,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="正三角形"
          imagePath="images/setting-popup/object-drawing/btn_triangle_01"
          active={shapeKind === ShapeKind.EquilateralTriangle}
          onClick={() => {
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.EquilateralTriangle,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="二等辺三角形"
          imagePath="images/setting-popup/object-drawing/btn_triangle_02"
          active={shapeKind === ShapeKind.Triangle}
          onClick={() => {
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.Triangle,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="多角形"
          imagePath="images/setting-popup/object-drawing/btn_polygon"
          active={shapeKind === ShapeKind.Polygon}
          onClick={() => {
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.Polygon,
              dispatch,
            );
          }} />
        <SelectableNormalIconButton
          title="スタンプ"
          imagePath="images/setting-popup/object-drawing/btn_stamp"
          active={shapeKind === ShapeKind.Stamp}
          onClick={() => {
            ObjectDrawingUIAction.setShapeKind(
              selected,
              ShapeKind.Stamp,
              dispatch,
            );
          }} />
      </ToolIconRadioButtonSet>
    </SettingTabPanelListRow>
  );
});

const mapStateToProps = (appStates: AppStates) => {
  const { selected, toolSettings } = appStates.ui.objectDrawing;
  return {
    selected,
    lineType: toolSettings[selected].lineType,
    shapeKind: toolSettings[selected].shapeKind,
  };
};

export default connect(mapStateToProps)(ShapeKindTabPanelListRow);
